// Smart API URL: uses REACT_APP_BACKEND_URL in development/preview,
// falls back to current page origin in production (custom domains)
function getApiUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === 'undefined') return envUrl || '';
  
  // If the page is loaded on a different domain than the env URL, use the page's origin
  // This handles custom domains where the env URL points to the Emergent deployment
  try {
    const envHost = envUrl ? new URL(envUrl).hostname : '';
    const pageHost = window.location.hostname;
    
    if (pageHost !== 'localhost' && envHost !== pageHost) {
      return window.location.origin;
    }
  } catch (e) {
    // If URL parsing fails, fall back to env URL
  }
  
  return envUrl || '';
}

export const API_URL = getApiUrl();
